import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  FlightAudit,
  FlightBusinessPersonAudit,
  FlightCrewMemberAudit,
  FlightCrewMemberCateringAudit,
  FlightCrewMemberHotelAudit,
  FlightCrewMemberTransportationAudit,
  FlightPassengerAudit,
  FlightPassengerCateringAudit,
  FlightPassengerHotelAudit,
  FlightPassengerTransportationAudit,
  LegNoteAudit,
  ScheduledAircraftTripAudit,
  ScheduledAircraftTripSkeleton,
  ScheduledEventAudit,
  FlightFuelAudit,
  DeletedTripItem,
  AuditLogLite,
  DeletedTripLegItem,
  FlightCrewMemberItem,
  FlightPassengerItem
} from '../../+models/trip-audit.model';

@Component({
  selector: 'sd-portal-deleted-trips-audit',
  templateUrl: './deleted-trips.component.html',
  styleUrls: ['./deleted-trips.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeletedTripsComponent implements OnInit {
  // Inputs
  @Input() deletedScheduledAircraftTripSkeletonsLoaded: boolean;
  @Input() deletedScheduledAircraftTripSkeletonsLoading: boolean;
  @Input() deletedScheduledAircraftTripSkeletons: ScheduledAircraftTripSkeleton[];

  @Input() scheduledAircraftTripAuditLoaded: boolean;
  @Input() scheduledAircraftTripAuditLoading: boolean;
  @Input() scheduledAircraftTripAudits: ScheduledAircraftTripAudit[];

  @Input() legAuditLoaded: boolean;
  @Input() legAuditLoading: boolean;
  @Input() legAudits: FlightAudit[];

  @Input() flightPassengerAuditLoaded: boolean;
  @Input() flightPassengerAuditLoading: boolean;
  @Input() flightPassengerAudits: FlightPassengerAudit[];

  @Input() flightPassengerCateringAuditLoaded: boolean;
  @Input() flightPassengerCateringAuditLoading: boolean;
  @Input() flightPassengerCateringAudits: FlightPassengerCateringAudit[];

  @Input() flightPassengerHotelAuditLoaded: boolean;
  @Input() flightPassengerHotelAuditLoading: boolean;
  @Input() flightPassengerHotelAudits: FlightPassengerHotelAudit[];

  @Input() flightPassengerTransportationAuditLoaded: boolean;
  @Input() flightPassengerTransportationAuditLoading: boolean;
  @Input() flightPassengerTransportationAudits: FlightPassengerTransportationAudit[];

  @Input() flightCrewMemberAuditLoaded: boolean;
  @Input() flightCrewMemberAuditLoading: boolean;
  @Input() flightCrewMemberAudits: FlightCrewMemberAudit[];

  @Input() flightCrewMemberCateringAuditLoaded: boolean;
  @Input() flightCrewMemberCateringAuditLoading: boolean;
  @Input() flightCrewMemberCateringAudits: FlightCrewMemberCateringAudit[];

  @Input() flightCrewMemberHotelAuditLoaded: boolean;
  @Input() flightCrewMemberHotelAuditLoading: boolean;
  @Input() flightCrewMemberHotelAudits: FlightCrewMemberHotelAudit[];

  @Input() flightCrewMemberTransportationAuditLoaded: boolean;
  @Input() flightCrewMemberTransportationAuditLoading: boolean;
  @Input() flightCrewMemberTransportationAudits: FlightCrewMemberTransportationAudit[];

  @Input() flightBusinessPersonAuditLoaded: boolean;
  @Input() flightBusinessPersonAuditLoading: boolean;
  @Input() flightBusinessPersonAudits: FlightBusinessPersonAudit[];

  @Input() scheduledEventAuditLoaded: boolean;
  @Input() scheduledEventAuditLoading: boolean;
  @Input() scheduledEventAudits: ScheduledEventAudit[];

  @Input() legNoteAuditLoaded: boolean;
  @Input() legNoteAuditLoading: boolean;
  @Input() legNoteAudits: LegNoteAudit[];

  @Input() flightFuelAuditLoaded: boolean;
  @Input() flightFuelAuditLoading: boolean;
  @Input() flightFuelAudits: FlightFuelAudit[];

  // V2 Inputs for lazy loading
  @Input() deletedTripsLoading: boolean;
  @Input() deletedTripsLoaded: boolean;
  @Input() deletedTrips: DeletedTripItem[];

  @Input() tripLogsLoading: boolean;
  @Input() tripLogsLoaded: boolean;
  @Input() tripLogs: AuditLogLite[];
  @Input() tripLogsHasMore: boolean;

  @Input() deletedTripLegsLoading: boolean;
  @Input() deletedTripLegsLoaded: boolean;
  @Input() deletedTripLegs: DeletedTripLegItem[];
  @Input() deletedTripLegsHasMore: boolean;

  @Input() legEventLogsLoading: boolean;
  @Input() legEventLogsLoaded: boolean;
  @Input() legEventLogs: AuditLogLite[];
  @Input() legEventLogsHasMore: boolean;

  @Input() legFlightLogsLoading: boolean;
  @Input() legFlightLogsLoaded: boolean;
  @Input() legFlightLogs: AuditLogLite[];
  @Input() legFlightLogsHasMore: boolean;

  @Input() legFuelLogsLoading: boolean;
  @Input() legFuelLogsLoaded: boolean;
  @Input() legFuelLogs: AuditLogLite[];
  @Input() legFuelLogsHasMore: boolean;

  @Input() flightCrewMembersLoading: boolean;
  @Input() flightCrewMembersLoaded: boolean;
  @Input() flightCrewMembers: FlightCrewMemberItem[];
  @Input() flightCrewMembersHasMore: boolean;

  @Input() crewLogsLoading: boolean;
  @Input() crewLogsLoaded: boolean;
  @Input() crewLogs: AuditLogLite[];
  @Input() crewLogsHasMore: boolean;

  @Input() crewCateringLogsLoading: boolean;
  @Input() crewCateringLogsLoaded: boolean;
  @Input() crewCateringLogs: AuditLogLite[];
  @Input() crewCateringLogsHasMore: boolean;

  @Input() crewHotelLogsLoading: boolean;
  @Input() crewHotelLogsLoaded: boolean;
  @Input() crewHotelLogs: AuditLogLite[];
  @Input() crewHotelLogsHasMore: boolean;

  @Input() crewTransportationLogsLoading: boolean;
  @Input() crewTransportationLogsLoaded: boolean;
  @Input() crewTransportationLogs: AuditLogLite[];
  @Input() crewTransportationLogsHasMore: boolean;

  @Input() flightPassengersLoading: boolean;
  @Input() flightPassengersLoaded: boolean;
  @Input() flightPassengers: FlightPassengerItem[];
  @Input() flightPassengersHasMore: boolean;

  @Input() passengerLogsLoading: boolean;
  @Input() passengerLogsLoaded: boolean;
  @Input() passengerLogs: AuditLogLite[];
  @Input() passengerLogsHasMore: boolean;

  @Input() passengerCateringLogsLoading: boolean;
  @Input() passengerCateringLogsLoaded: boolean;
  @Input() passengerCateringLogs: AuditLogLite[];
  @Input() passengerCateringLogsHasMore: boolean;

  @Input() passengerHotelLogsLoading: boolean;
  @Input() passengerHotelLogsLoaded: boolean;
  @Input() passengerHotelLogs: AuditLogLite[];
  @Input() passengerHotelLogsHasMore: boolean;

  @Input() passengerTransportationLogsLoading: boolean;
  @Input() passengerTransportationLogsLoaded: boolean;
  @Input() passengerTransportationLogs: AuditLogLite[];
  @Input() passengerTransportationLogsHasMore: boolean;

  // Outputs
  @Output() skeletonsNextPage = new EventEmitter<void>();

  @Output() tripOpened = new EventEmitter<number>();
  @Output() tripNextPage = new EventEmitter<number>();

  @Output() legOpened = new EventEmitter<number>();
  @Output() legNextPage = new EventEmitter<number>();

  @Output() passengerOpened = new EventEmitter<number>();
  @Output() passengerNextPage = new EventEmitter<number>();

  @Output() passengerCateringOpened = new EventEmitter<number>();
  @Output() passengerCateringNextPage = new EventEmitter<number>();

  @Output() passengerHotelOpened = new EventEmitter<number>();
  @Output() passengerHotelNextPage = new EventEmitter<number>();

  @Output() passengerTransportationOpened = new EventEmitter<number>();
  @Output() passengerTransportationNextPage = new EventEmitter<number>();

  @Output() crewMemberOpened = new EventEmitter<number>();
  @Output() crewMemberNextPage = new EventEmitter<number>();

  @Output() crewMemberCateringOpened = new EventEmitter<number>();
  @Output() crewMemberCateringNextPage = new EventEmitter<number>();

  @Output() crewMemberHotelOpened = new EventEmitter<number>();
  @Output() crewMemberHotelNextPage = new EventEmitter<number>();

  @Output() crewMemberTransportationOpened = new EventEmitter<number>();
  @Output() crewMemberTransportationNextPage = new EventEmitter<number>();

  @Output() businessPersonOpened = new EventEmitter<number>();
  @Output() businessPersonNextPage = new EventEmitter<number>();

  @Output() scheduledEventOpened = new EventEmitter<number>();
  @Output() scheduledEventNextPage = new EventEmitter<number>();

  @Output() legNoteOpened = new EventEmitter<number>();
  @Output() legNoteNextPage = new EventEmitter<number>();

  @Output() flightFuelOpened = new EventEmitter<number>();
  @Output() flightFuelNextPage = new EventEmitter<number>();

  // V2 Outputs for lazy loading
  @Output() deletedTripOpened = new EventEmitter<number>();
  @Output() deletedTripNextPage = new EventEmitter<number>();

  @Output() deletedTripLegsOpened = new EventEmitter<number>();
  @Output() deletedTripLegsNextPage = new EventEmitter<number>();

  @Output() legEventLogsOpened = new EventEmitter<number>();
  @Output() legEventLogsNextPage = new EventEmitter<number>();

  @Output() legFlightLogsOpened = new EventEmitter<number>();
  @Output() legFlightLogsNextPage = new EventEmitter<number>();

  @Output() legFuelLogsOpened = new EventEmitter<number>();
  @Output() legFuelLogsNextPage = new EventEmitter<number>();

  @Output() flightCrewMembersOpened = new EventEmitter<number>();
  @Output() flightCrewMembersNextPage = new EventEmitter<number>();
  @Output() crewLogsOpened = new EventEmitter<number>();
  @Output() crewLogsNextPage = new EventEmitter<number>();
  @Output() crewCateringLogsOpened = new EventEmitter<number>();
  @Output() crewCateringLogsNextPage = new EventEmitter<number>();
  @Output() crewHotelLogsOpened = new EventEmitter<number>();
  @Output() crewHotelLogsNextPage = new EventEmitter<number>();
  @Output() crewTransportationLogsOpened = new EventEmitter<number>();
  @Output() crewTransportationLogsNextPage = new EventEmitter<number>();

  @Output() flightPassengersOpened = new EventEmitter<number>();
  @Output() flightPassengersNextPage = new EventEmitter<number>();
  @Output() passengerLogsOpened = new EventEmitter<number>();
  @Output() passengerLogsNextPage = new EventEmitter<number>();
  @Output() passengerCateringLogsOpened = new EventEmitter<number>();
  @Output() passengerCateringLogsNextPage = new EventEmitter<number>();
  @Output() passengerHotelLogsOpened = new EventEmitter<number>();
  @Output() passengerHotelLogsNextPage = new EventEmitter<number>();
  @Output() passengerTransportationLogsOpened = new EventEmitter<number>();
  @Output() passengerTransportationLogsNextPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}
}
